import { render, staticRenderFns } from "./ProcessTypeEdit.vue?vue&type=template&id=5e716018&"
import script from "./ProcessTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ProcessTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports